import { render } from "./GameRulesModal.vue?vue&type=template&id=080d162d&scoped=true"
import script from "./GameRulesModal.vue?vue&type=script&lang=js"
export * from "./GameRulesModal.vue?vue&type=script&lang=js"

import "./GameRulesModal.vue?vue&type=style&index=0&id=080d162d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080d162d"]])

export default __exports__